import { ACTIONS } from '../constants/user-inventory';
import { MODE } from '../constants/mode';

const INITIAL_STATE = {
  userInventoryList: { userInventories: [], params: {}, pager: null, error: null, loading: false },
  activeUserInventory: { userInventory: null, error: null, mode: null },
};

export const userInventory = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTIONS.USER_INVENTORY_CREATE_RESET:
    case ACTIONS.USER_INVENTORY_UPDATE_RESET:
    case ACTIONS.USER_INVENTORY_DELETE_RESET:
    case ACTIONS.USER_INVENTORY_FETCH_RESET:
      return {
        ...state,
        activeUserInventory: {
          userInventory: null,
          loading: false,
          error: null,
          mode: null,
        },
      };

    //================================== USER_INVENTORY CREATE START ==================================//
    case ACTIONS.USER_INVENTORY_CREATE_START:
      return {
        ...state,
        activeUserInventory: {
          userInventory: action.payload,
          loading: true,
          error: null,
          mode: MODE.CREATE,
        },
      };
    case ACTIONS.USER_INVENTORY_CREATE_FAILURE:
      return {
        ...state,
        activeUserInventory: {
          userInventory: null,
          loading: false,
          error: action.payload,
          mode: MODE.CREATE,
        },
      };
    case ACTIONS.USER_INVENTORY_CREATE_SUCCESS:
      return {
        ...state,
        userInventoryList: {
          ...state.userInventoryList,
          userInventories: state.userInventoryList.userInventories.concat(action.payload),
          error: null,
          loading: false,
        },
        activeUserInventory: {
          userInventory: action.payload,
          loading: false,
          error: null,
          mode: MODE.CREATE,
        },
      };

    //==================================  USER_INVENTORY CREATE END  ==================================//
    //================================== USER_INVENTORY UPDATE START ==================================//
    case ACTIONS.USER_INVENTORY_UPDATE_START:
      return {
        ...state,
        activeUserInventory: {
          userInventory: action.payload,
          loading: true,
          error: null,
          mode: MODE.UPDATE,
        },
      };
    case ACTIONS.USER_INVENTORY_UPDATE_FAILURE:
      return {
        ...state,
        activeUserInventory: {
          userInventory: null,
          loading: false,
          error: action.payload,
          mode: MODE.UPDATE,
        },
      };
    case ACTIONS.USER_INVENTORY_UPDATE_SUCCESS:
      return {
        ...state,
        userInventoryList: {
          ...state.userInventoryList,
          userInventories: state.userInventoryList.userInventories.map(inv => {
            if (inv.id === action.payload.id) {
              inv = action.payload;
            }
            return inv;
          }),
          error: null,
          loading: false,
        },
        activeUserInventory: {
          userInventory: action.payload,
          loading: false,
          error: null,
          mode: MODE.UPDATE,
        },
      };
    //==================================  USER_INVENTORY UPDATE END  ==================================//
    //================================== USER_INVENTORY DELETE START ==================================//
    case ACTIONS.USER_INVENTORY_DELETE_START:
      return {
        ...state,
        activeUserInventory: {
          userInventory: action.payload,
          loading: true,
          error: null,
          mode: MODE.DELETE,
        },
      };
    case ACTIONS.USER_INVENTORY_DELETE_FAILURE:
      return {
        ...state,
        activeUserInventory: {
          userInventory: null,
          loading: false,
          error: action.payload,
          mode: MODE.DELETE,
        },
      };
    case ACTIONS.USER_INVENTORY_DELETE_SUCCESS:
      return {
        ...state,
        userInventoryList: {
          ...state.userInventoryList,
          userInventories: state.userInventoryList.userInventories.filter(
            inventoryItem => inventoryItem.id !== action.payload.id
          ),
          error: null,
          loading: false,
        },
        activeUserInventory: {
          userInventory: action.payload,
          loading: false,
          error: null,
          mode: MODE.DELETE,
        },
      };
    //==================================  USER_INVENTORY DELETE END  ==================================//
    //================================== USER_INVENTORY FETCH START ==================================//
    case ACTIONS.USER_INVENTORY_FETCH_START:
      return {
        ...state,
        activeUserInventory: {
          userInventory: action.payload,
          loading: true,
          error: null,
          mode: MODE.VIEW,
        },
      };
    case ACTIONS.USER_INVENTORY_FETCH_FAILURE:
      return {
        ...state,
        activeUserInventory: {
          userInventory: null,
          loading: false,
          error: action.payload,
          mode: MODE.VIEW,
        },
      };
    case ACTIONS.USER_INVENTORY_FETCH_SUCCESS:
      return {
        ...state,
        activeUserInventory: {
          userInventory: action.payload,
          loading: false,
          error: null,
          mode: MODE.VIEW,
        },
      };
    //==================================  USER_INVENTORY FETCH END  ==================================//
    //================================== USER_INVENTORIES FETCH START ==================================//
    case ACTIONS.USER_INVENTORIES_FETCH_START:
      return {
        ...state,
        userInventoryList: {
          userInventories: [],
          params: action.payload,
          pager: null,
          error: null,
          loading: true,
        },
      };
    case ACTIONS.USER_INVENTORIES_FETCH_SUCCESS:
      return {
        ...state,
        userInventoryList: {
          ...state.userInventoryList,
          userInventories: action.payload.results,
          pager: action.payload.paginator,
          error: null,
          loading: false,
        },
      };
    case ACTIONS.USER_INVENTORIES_FETCH_FAILURE:
      return {
        ...state,
        userInventoryList: {
          ...state.userInventoryList,
          userInventories: [],
          pager: null,
          error: action.payload,
          loading: false,
        },
      };
    case ACTIONS.USER_INVENTORIES_FETCH_RESET:
      return {
        ...state,
        userInventoryList: {
          userInventories: [],
          params: null,
          pager: null,
          error: null,
          loading: false,
        },
      };
    //==================================  USER_INVENTORIES FETCH END  ==================================//
    default:
      return state;
  }
};
